// Generated from legacy db.ts to keep files under 500 lines.
import { sql } from "../../base";
import type { DocumentReviewSession } from "../../types";

const documentReviewSessionsModule = {
  async create(data: Omit<DocumentReviewSession, 'id' | 'created_at' | 'duration_minutes'>): Promise<DocumentReviewSession> {
    const result = await sql`
      INSERT INTO document_review_sessions (
        user_id, document_id, time_entry_id, started_at, ended_at, action_taken
      )
      VALUES (
        ${data.user_id}, ${data.document_id}, ${data.time_entry_id}, 
        ${data.started_at}, ${data.ended_at}, ${data.action_taken}
      )
      RETURNING *
    `;
    return result[0] as DocumentReviewSession;
  },

  async endSession(id: string, userId: string, timeEntryId?: string, actionTaken?: string): Promise<DocumentReviewSession> {
    const result = await sql`
      UPDATE document_review_sessions
      SET 
        ended_at = NOW(),
        time_entry_id = CASE WHEN ${timeEntryId === undefined} THEN time_entry_id ELSE ${timeEntryId} END,
        action_taken = CASE WHEN ${actionTaken === undefined} THEN action_taken ELSE ${actionTaken} END
      WHERE id = ${id} AND user_id = ${userId}
      RETURNING *
    `;
    return result[0] as DocumentReviewSession;
  },

  async findActive(userId: string): Promise<DocumentReviewSession | null> {
    const result = await sql`
      SELECT * FROM document_review_sessions
      WHERE user_id = ${userId} AND ended_at IS NULL
      ORDER BY started_at DESC
      LIMIT 1
    `;
    return result[0] as DocumentReviewSession || null;
  }
};

export type DocumentReviewSessionsModule = typeof documentReviewSessionsModule;

export function registerDocumentReviewSessions(db: { documentReviewSessions?: DocumentReviewSessionsModule }) {
  db.documentReviewSessions = documentReviewSessionsModule;
}

export { documentReviewSessionsModule as documentReviewSessions };
